import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { DEPT_TABS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/tabs/new")({
  component: () => <DeptContentForm cfg={DEPT_TABS} />,
});
